import styled from 'styled-components';

const marginTopAndBottom = '64px';
const modalPaddingTopAndBottom = '48px';
const titleHeight = '26px';
const buttonInviteDriverHeight = '40px';
const contentSpacingTopAndBottom = '48px';

export const BenefitsContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km5};

  @media screen and (orientation: landscape) {
    max-height: calc(
      100vh - ${marginTopAndBottom} - ${modalPaddingTopAndBottom} - ${titleHeight} - ${buttonInviteDriverHeight} -
        ${contentSpacingTopAndBottom}
    );
    overflow: auto;
  }
`;
